<div class="address-input-container">
  <!-- This is still needed for form control binding -->
  <ig-field
    #inputElement
    [label]="label"
    [hint]="hint"
    [icon]="control.value ? 'clear' : 'room'"
    (onIconClick)="clear()"
    [control]="control"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    type="text"
    hidden
  ></ig-field>

  <div style="position: relative; width: 100%; display: flex; align-items: center;">
  <div (onIconClick)="clear()" #autocompleteContainer style="width: 100%"></div>
  <span style="
    position: absolute;
    right: 10px;
    top: 12px;
    pointer-events: none;
    font-family: 'Material Icons';
    font-size: 26px;
    color: #a9a9a9;
  ">
    place
  </span>
</div>

</div>